import { connect } from "react-redux";

import AuthLayout from "./AuthLayout";

const mapStateToProps = state => ({});

const mapDispatchToProps = dispatch => ({});

export default connect(mapStateToProps, mapDispatchToProps)(AuthLayout);
